module.exports = __webpack_public_path__ + "static/img/es.8413cd5.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-country-flags/svg/es.svg
// module id = JsqX
// module chunks = 1